let bottom = {
  contactUS: "联系我们",
  followUS: "关注我们",
  product: {
    title: "产品采购",
    dynamic: "动态房屋",
    data: "数据中心",
    mobile: "移动代理"
  },
  howToUse: {
    title: "如何使用",
    extract: "提取API",
    ledger: "获取API",
    browser: "浏览器插件"
  },
  applications: {
    title: "我的应用程序",
    href: "我的应用程序",
    eCommerce: "电子商务",
    website: "网站测试",
    social: "社会化媒体",
    seo: "SEO优化",
    price: "价格比较",
    ad: "广告验证",
    mail: "邮件保护",
    market: "市场调查"
  },
  resource: {
    title: "资源中心",
    problem: "常见问题",
    document: "产品文档",
    api: "公共API"
  },
  legal: {
    title: "法律",
    privacy: "隐私政策",
    cookie: "Cookie政策"
  }
}

export default bottom


// WEBPACK FOOTER //
// ./src/assets/lang/zh/bottom/index.js